import { Component, OnInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { Location } from "@angular/common";
import { CoreLogService } from "../../services/log.service";
import { Router } from "@angular/router";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { WebShopService } from "../../services/webShop.service";
import { CoreLanguageService } from "../../services/language.service";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { Subscription } from "rxjs/Subscription";
import { GroupOrderOverviewService } from "./groupOrderOverview.service";
import { Observable } from "rxjs";
import { IGroupMemberItems, IGroupInfo, IMenuCourse, IGroupMember } from "./groupOrderOverview.facade";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { SecureCheckDialogComponent } from "../../modalDialogs";
import { InHouseOrderService } from "../../services/inHouseOrder.service";
import { req_Order, OrderType, OrderStatus } from "../../services/IInHouseOrderService";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { SnackBarService } from "../../services/snackBar.service";
import { GroupStateService } from "../../services/groupState.service";

@Component({
  selector: "groupOrderOverview",
  templateUrl: "./groupOrderOverview.component.html",
  styleUrls: ["./groupOrderOverview.component.scss"],
  providers: [GroupOrderOverviewService, OverlaySpinnerService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class GroupOrderOverviewComponent implements OnInit, OnDestroy {
  private _langSubscriber: Subscription;

  public isSmallView: boolean = false;
  public displayToggle: boolean = false;
  public show_more: boolean = false;
  // count of members to display on load
  public limitCount: number = 6;
  public commentVisibleInitilize: boolean = true;

  public groupMember$: Observable<IGroupMember[]>;
  public menucourses$: Observable<IMenuCourse[]>;
  public groupbasketItems$: Observable<IGroupMemberItems[]>;
  public open_price$: Observable<number>;
  public item_count$: Observable<number>;
  public readyforpickupCount$: Observable<number>;
  public userToken: string;
  public showShareLink: boolean = false;

  constructor(private _location: Location
    , private _router: Router
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _coreLanguageService: CoreLanguageService
    , private _mainnavService: MainnavService
    , private internationalisationService: InternationalisationService
    , private _webShopService: WebShopService
    , private _groupOverviewService: GroupOrderOverviewService
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _inHouseOrderService: InHouseOrderService
    , private _overlaySpinnerService: OverlaySpinnerService
    , private _snackBarService: SnackBarService
    , private _groupStateService: GroupStateService
  ) {
    const me = this;
    me.isSmallView = me._mainnavService.viewType === ViewType.Small;
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("GroupOrderOverviewComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.groupMember$ = me._groupOverviewService.groupMember$;
    me.groupbasketItems$ = me._groupOverviewService.groupMemberItemsGroups$;
    me.menucourses$ = me._groupOverviewService.menucourses$;
    me.open_price$ = me._groupOverviewService.open_price$;
    me.item_count$ = me._groupOverviewService.item_count$;
    me.readyforpickupCount$ = me._groupOverviewService.readyforpickupCount$;

    me._langSubscriber = me.internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });
    me.groupUI = me._groupOverviewService.GroupInfo;
    me.PushChanges();
  }

  public trackMemberOverviewBy(member: IGroupMember) {
    return member.userToken;
  }

  private groupUI: IGroupInfo;

  public get groupName(): string {
    return this.groupUI.groupName;
  }

  /**User list title */
  public get groupOverViewTitle(): string {
    const me = this;
    return me._coreLanguageService.value("phGroupOrder_GroupOverview_Title")
      .replace("{groupName}", `<br><span class="emphasized">${me.groupUI.groupName}</span><br>`)
      .replace("{groupCreatorName}", `<span class="emphasized">${me.groupUI.groupCreator}</span>`);
  }

  public setItemsAmount(amount: number) {
    const me = this;
    return me._webShopService.formatCurrency(amount);
  }

  /** Ordering information of each group member*/
  public setItemsCount(count: number): string {
    return count.toString();
  }

  /** group basket items count*/
  public setIGroupOrderedCount(count: number) {
    return count.toString();
  }

  public Displaytoggle(memberCount: number): boolean {
    const me = this;
    return memberCount > me.limitCount ? me.displayToggle = true : me.displayToggle = false;
  }

  /** toggle show more/less */
  public toggleShowMore() {
    const me = this;
    me.show_more = !me.show_more;
  }

  /**send Group Order */
  public sendGroupOrder() {
    const me = this;
    const dialog = me._bottomSheetHelperService.open(SecureCheckDialogComponent, {
      data: {
        title: "phGroupOrder_SendOrderDialog_Title",
        description: "phGroupOrder_SendOrderDialog_Description",
        buttonTextAccept: "phGroupOrder_SendOrderDialog_AcceptBtn",
        buttonTextDeny: "phGroupOrder_SendOrderDialog_DenyBtn",
        icon: "shop-icons.svg#ya-hypersoft-achtung",
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    dialog.afterDismissed().subscribe((result: any) => {
      if (result) {
        const request: req_Order = {
          order_type: OrderType.GroupBasket,
        };
        me._overlaySpinnerService.ShowLayoutSpinner();
        me._inHouseOrderService.Order(request).then((response) => {
          me._overlaySpinnerService.HideLayoutSpinner();
          if (response.status === OrderStatus.Okay) {
            me._webShopService.clearItems(); // items from basket to table
            me._router.navigate(["/inHauseOrderConfirm"]);
          } else {
            me._coreLogService.error("WebshopService._orderInhouse", "Order status not Okay", response.status);
            me._snackBarService.ShowErrorMessageFailed(32);
          }
        }).catch((error) => {
          me._overlaySpinnerService.HideLayoutSpinner();
          me._coreLogService.error("WebshopService._orderInhouse", "Order catch", error);
          me._snackBarService.ShowErrorMessageFailed(33);
        });
      } //else nothing
    })
  }

  public currentlyUserIsOwner(userToken: string): boolean {
    const isOwner = userToken === this._inHouseOrderService.UserToken;
    return isOwner;
  }

  public isGroupCreator(): boolean {
    const isCreator = this._inHouseOrderService.GroupCreator === this._inHouseOrderService.UserNickname;
    return isCreator;
  }

  public ViewGroupMemberOrder(userToken: string) {
    const me = this;
    me._router.navigate(["/groupMemberOrderDetail", userToken]);
  }

  /** Navigation to GroupOrderInvite view */
  public NavigateToShareLink() {
    const me = this;
    this._groupStateService.setshownavigatetomenu(false);
    me._router.navigate(['/groupOrderShare']);
  }

  /** navigate back on swipe from left to right */
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me.navigateBack();
    }
  }

  /** navigate back */
  public navigateBack(): void {
    this._location.back();
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._langSubscriber) {
      me._langSubscriber.unsubscribe();
    }
  }
}
